import React from 'react'
import { IOrder } from 'order_components/IOrder'
import './StyleOrderStatus.css'

const statusTheme = (statusId: number) => {
  const arr = [
    'secondary',
    'warning',
    'info',
    'info',
    'secondary',
    'secondary',
    'success',
    'danger',
    'danger',
  ]
  if (statusId >= arr.length || statusId < 0) return arr[0]
  return arr[statusId]
}

interface IOrderStatusProps {
  order: IOrder
}

const OrderStatus: React.FC<IOrderStatusProps> = ({ order }) => {
  return (
    <div>
      <span className={'order-status-span ' + statusTheme(order.status_id)}>
        {order.client_display}
      </span>
    </div>
  )
}
export default OrderStatus
